import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import PleaseLoginPrompt from "./PleaseLoginPrompt.jsx";
import { sitePolicyState } from "../utils/Utils.js";
import useMiniSite from "../hooks/useMiniSite";
import olympiacosLoginIcon from "../assets/images/olympiacos-login-icon.png";

const DEFAULT_ICON = "/Site/Images/icons/user-with-bell.png";


const REASON_KEY = {
  NotLoggedIn: "SignIn",
  TermsNotAccepted: "CompleteProfile",
  MissingCity: "CompleteProfile",
  MissingCountry: "CompleteProfile",
};

const INTENT_KEY = {
  view: "ToViewEvent",
  buy: "ToBuyTickets",
};

const SitePolicyPrompt = forwardRef(({ intent = "view", mandatory = true, autoOpen = true, onClose, onBeforeLogin }, ref) => {
  const promptRef = useRef();
  const [forcedReason, setForcedReason] = useState(null);
  const [targetUrl, setTargetUrl] = useState(null);
  const { isOlympiacos } = useMiniSite();
  const icon = isOlympiacos ? olympiacosLoginIcon : DEFAULT_ICON;
  const [openSeq, setOpenSeq] = useState(0);
  const reason = forcedReason || sitePolicyState();

  useImperativeHandle(ref, () => ({
    open: (r, url) => {
      setForcedReason(r || sitePolicyState() || "NotLoggedIn");
      if (url !== undefined) setTargetUrl(url);
      setOpenSeq((n) => n + 1);
    },
  }));

  useEffect(() => {
    if (autoOpen && reason) {
      promptRef.current?.handleOpen();
    }
  }, [reason, autoOpen]);

  useEffect(() => {
    if (openSeq > 0 && reason) {
      promptRef.current?.handleOpen();
    }
  }, [openSeq]);

  if (!reason) return null;

  const isNotLoggedIn = reason === "NotLoggedIn";
  // Incomplete-profile reasons only reach this modal on view pages; buy pages redirect them server-side.
  const resourceKey = REASON_KEY[reason] + (isNotLoggedIn ? INTENT_KEY[intent] : INTENT_KEY.view);

  const handleLoginClick = () => {
    const resolved = targetUrl ? new URL(targetUrl, window.location.href).href : window.location.href;
    const origin = encodeURIComponent(resolved);
    const lang = $("html").attr("lang") ?? "el";
    onBeforeLogin?.();
    window.location.href = `/Challenge.aspx?origin=${origin}&terms=olympiacos&lang=${lang}`;
  };

  return (
    <PleaseLoginPrompt
      ref={promptRef}
      icon={icon}
      prompt={tickets_resources[resourceKey]}
      btnText={isNotLoggedIn ? tickets_resources.SignIn : tickets_resources.Continue}
      mandatory={mandatory}
      loginClickCallBack={handleLoginClick}
      onClose={onClose}
    />
  );
});

export default SitePolicyPrompt;
